// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jrnce6 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-1);
  border-radius: var(--radius-s);
  border-width: 2px;
  border-style: solid;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  box-sizing: border-box;
  font-size: var(--size);
}

.Z_F1g_ {
  filter: var(--button-icon-filter);
  height: var(--size);
  width: var(--size);
}

.EbWxVA {
  color: var(--button-text-color);
  font-size: var(--size);
}

/* sizes */
.khg4E6 {
  padding: var(--spacing-1-5) var(--spacing-2);
  --size: var(--font-size-lg);
}

.uZPgYx {
  padding: var(--spacing-1) var(--spacing-1-5);
  --size: var(--font-size-md);
}

.fuEwdI {
  padding: var(--spacing-0-5) var(--spacing-1);
  --size: var(--font-size-sm);
}

/* primary */
.m6NiDv {
  --button-text-color: var(--text-neutral-white);
  --button-icon-filter: brightness(0) saturate(100%) invert(100%);
  background: var(--surface-primary-medium);
  border-color: var(--surface-primary-medium);
}

.m6NiDv:not([disabled]):hover {
  background: var(--surface-primary-bright);
  border-color: var(--surface-primary-bright);
}

.m6NiDv:not([disabled]):active {
  background: var(--surface-primary-strong);
  border-color: var(--surface-primary-strong);
}

.m6NiDv:disabled {
  background: var(--surface-neutral-soft);
  border-color: var(--surface-neutral-soft);
  --button-text-color: var(--text-neutral-strong);
  --button-icon-filter: brightness(0) saturate(100%) invert(83%) sepia(10%) saturate(0%) hue-rotate(154deg)
    brightness(77%) contrast(88%);
}

/* secondary */
.ha8pBU {
  --button-text-color: var(--text-primary-medium);
  --button-icon-filter: brightness(0) saturate(100%) invert(38%) sepia(58%) saturate(4955%) hue-rotate(11deg)
    brightness(98%) contrast(97%);
  background: transparent;
  border-color: var(--text-primary-medium);
}

.ha8pBU:not([disabled]):hover {
  --button-text-color: var(--text-primary-bright);
  background: transparent;
  border-color: var(--text-primary-bright);
}

.ha8pBU:not([disabled]):active {
  --button-text-color: var(--text-primary-strong);
  background: transparent;
  border-color: var(--text-primary-strong);
}

.ha8pBU:disabled {
  background: transparent;
  border-color: var(--stroke-neutral-silver);
  --button-text-color: var(--text-neutral-silver);
  --button-icon-filter: brightness(0) saturate(100%) invert(83%) sepia(10%) saturate(0%) hue-rotate(154deg)
    brightness(87%) contrast(88%);
}

/* tertiary */
.uDTglp {
  --button-text-color: var(--text-primary-medium);
  --button-icon-filter: brightness(0) saturate(100%) invert(38%) sepia(58%) saturate(4955%) hue-rotate(11deg)
    brightness(98%) contrast(97%);
  background: transparent;
  border-color: transparent;
}

.uDTglp:not([disabled]):hover {
  --button-text-color: var(--text-primary-bright);
  background: transparent;
  border-color: transparent;
}

.uDTglp:not([disabled]):active {
  --button-text-color: var(--text-primary-strong);
  background: transparent;
  border-color: transparent;
}

.uDTglp:disabled {
  background: transparent;
  border-color: transparent;
  --button-text-color: var(--text-neutral-silver);
  --button-icon-filter: brightness(0) saturate(100%) invert(83%) sepia(10%) saturate(0%) hue-rotate(154deg)
    brightness(97%) contrast(88%);
}

/* outline */
.Sc7sHy {
  --button-text-color: var(--text-primary-medium);
  --button-icon-filter: brightness(0) saturate(100%) invert(38%) sepia(58%) saturate(4955%) hue-rotate(11deg)
    brightness(98%) contrast(97%);
  background: var(--surface-neutral-white);
  border-color: var(--text-primary-medium);
}

.Sc7sHy:not([disabled]):hover {
  --button-text-color: var(--text-primary-bright);
  background: var(--surface-neutral-soft);
  border-color: var(--text-primary-bright);
}

.Sc7sHy:not([disabled]):active {
  --button-text-color: var(--text-primary-strong);
  background: var(--surface-neutral-soft);
  border-color: var(--text-primary-strong);
}

.Sc7sHy:disabled {
  background: var(--surface-neutral-white);
  border-color: var(--stroke-neutral-silver);
  --button-text-color: var(--text-neutral-silver);
  --button-icon-filter: brightness(0) saturate(100%) invert(83%) sepia(10%) saturate(0%) hue-rotate(154deg)
    brightness(87%) contrast(88%);
}

.jrnce6:disabled {
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Button/Button.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,oCAAoC;EACpC,wCAAwC;EACxC,eAAe;EACf,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;EACE,8CAA8C;EAC9C,+DAA+D;EAC/D,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,+CAA+C;EAC/C;iCAC+B;AACjC;;AAEA,cAAc;AACd;EACE,+CAA+C;EAC/C;iCAC+B;EAC/B,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,+CAA+C;EAC/C;iCAC+B;AACjC;;AAEA,aAAa;AACb;EACE,+CAA+C;EAC/C;iCAC+B;EAC/B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,+CAA+C;EAC/C;iCAC+B;AACjC;;AAEA,YAAY;AACZ;EACE,+CAA+C;EAC/C;iCAC+B;EAC/B,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,+CAA+C;EAC/C,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,+CAA+C;EAC/C,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,+CAA+C;EAC/C;iCAC+B;AACjC;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-1);\n  border-radius: var(--radius-s);\n  border-width: 2px;\n  border-style: solid;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  cursor: pointer;\n  box-sizing: border-box;\n  font-size: var(--size);\n}\n\n.icon {\n  filter: var(--button-icon-filter);\n  height: var(--size);\n  width: var(--size);\n}\n\n.label {\n  color: var(--button-text-color);\n  font-size: var(--size);\n}\n\n/* sizes */\n.large {\n  padding: var(--spacing-1-5) var(--spacing-2);\n  --size: var(--font-size-lg);\n}\n\n.medium {\n  padding: var(--spacing-1) var(--spacing-1-5);\n  --size: var(--font-size-md);\n}\n\n.small {\n  padding: var(--spacing-0-5) var(--spacing-1);\n  --size: var(--font-size-sm);\n}\n\n/* primary */\n.primary {\n  --button-text-color: var(--text-neutral-white);\n  --button-icon-filter: brightness(0) saturate(100%) invert(100%);\n  background: var(--surface-primary-medium);\n  border-color: var(--surface-primary-medium);\n}\n\n.primary:not([disabled]):hover {\n  background: var(--surface-primary-bright);\n  border-color: var(--surface-primary-bright);\n}\n\n.primary:not([disabled]):active {\n  background: var(--surface-primary-strong);\n  border-color: var(--surface-primary-strong);\n}\n\n.primary:disabled {\n  background: var(--surface-neutral-soft);\n  border-color: var(--surface-neutral-soft);\n  --button-text-color: var(--text-neutral-strong);\n  --button-icon-filter: brightness(0) saturate(100%) invert(83%) sepia(10%) saturate(0%) hue-rotate(154deg)\n    brightness(77%) contrast(88%);\n}\n\n/* secondary */\n.secondary {\n  --button-text-color: var(--text-primary-medium);\n  --button-icon-filter: brightness(0) saturate(100%) invert(38%) sepia(58%) saturate(4955%) hue-rotate(11deg)\n    brightness(98%) contrast(97%);\n  background: transparent;\n  border-color: var(--text-primary-medium);\n}\n\n.secondary:not([disabled]):hover {\n  --button-text-color: var(--text-primary-bright);\n  background: transparent;\n  border-color: var(--text-primary-bright);\n}\n\n.secondary:not([disabled]):active {\n  --button-text-color: var(--text-primary-strong);\n  background: transparent;\n  border-color: var(--text-primary-strong);\n}\n\n.secondary:disabled {\n  background: transparent;\n  border-color: var(--stroke-neutral-silver);\n  --button-text-color: var(--text-neutral-silver);\n  --button-icon-filter: brightness(0) saturate(100%) invert(83%) sepia(10%) saturate(0%) hue-rotate(154deg)\n    brightness(87%) contrast(88%);\n}\n\n/* tertiary */\n.tertiary {\n  --button-text-color: var(--text-primary-medium);\n  --button-icon-filter: brightness(0) saturate(100%) invert(38%) sepia(58%) saturate(4955%) hue-rotate(11deg)\n    brightness(98%) contrast(97%);\n  background: transparent;\n  border-color: transparent;\n}\n\n.tertiary:not([disabled]):hover {\n  --button-text-color: var(--text-primary-bright);\n  background: transparent;\n  border-color: transparent;\n}\n\n.tertiary:not([disabled]):active {\n  --button-text-color: var(--text-primary-strong);\n  background: transparent;\n  border-color: transparent;\n}\n\n.tertiary:disabled {\n  background: transparent;\n  border-color: transparent;\n  --button-text-color: var(--text-neutral-silver);\n  --button-icon-filter: brightness(0) saturate(100%) invert(83%) sepia(10%) saturate(0%) hue-rotate(154deg)\n    brightness(97%) contrast(88%);\n}\n\n/* outline */\n.outline {\n  --button-text-color: var(--text-primary-medium);\n  --button-icon-filter: brightness(0) saturate(100%) invert(38%) sepia(58%) saturate(4955%) hue-rotate(11deg)\n    brightness(98%) contrast(97%);\n  background: var(--surface-neutral-white);\n  border-color: var(--text-primary-medium);\n}\n\n.outline:not([disabled]):hover {\n  --button-text-color: var(--text-primary-bright);\n  background: var(--surface-neutral-soft);\n  border-color: var(--text-primary-bright);\n}\n\n.outline:not([disabled]):active {\n  --button-text-color: var(--text-primary-strong);\n  background: var(--surface-neutral-soft);\n  border-color: var(--text-primary-strong);\n}\n\n.outline:disabled {\n  background: var(--surface-neutral-white);\n  border-color: var(--stroke-neutral-silver);\n  --button-text-color: var(--text-neutral-silver);\n  --button-icon-filter: brightness(0) saturate(100%) invert(83%) sepia(10%) saturate(0%) hue-rotate(154deg)\n    brightness(87%) contrast(88%);\n}\n\n.container:disabled {\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `jrnce6`,
	"icon": `Z_F1g_`,
	"label": `EbWxVA`,
	"large": `khg4E6`,
	"medium": `uZPgYx`,
	"small": `fuEwdI`,
	"primary": `m6NiDv`,
	"secondary": `ha8pBU`,
	"tertiary": `uDTglp`,
	"outline": `Sc7sHy`
};
module.exports = ___CSS_LOADER_EXPORT___;
